import { ReactNode } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'reflexbox';

import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import { ChevronRightIcon } from '@treams/treams-icons';

interface IChooserOption<T> {
	id: T;
	name: string;
	icon?: ReactNode;
}

interface IProps<T> {
	options: Array<IChooserOption<T>>;
	onChange: (value: IChooserOption<T>) => void;
}

const ChooserIconContainer = styled.div`
	display: inline-block;
	width: 32px;
	height: 32px;
	border-radius: 50px;
	margin-right: 8px;

	svg {
		width: 24px;

		* {
			fill: ${(props) => props.theme.colors.antracite};
		}
	}
`;

const ChooserOption = styled.button`
	background-color: ${(props) => props.theme.colors.white};
	border-radius: 6px;
	display: flex;
	align-items: center;
	width: 100%;
	padding: 12px 14px;
	border: 1px solid ${(props) => props.theme.colors.lightBlueLight};

	${Paragraph} {
		color: ${(props) => props.theme.colors.antracite};
		font-size: 16px;
		display: block;

		svg {
			margin-left: 8px;
			transform: translateY(2px);

			* {
				fill: ${(props) => props.theme.colors.antracite};
			}
		}
	}

	&:hover {
		background-color: ${(props) => props.theme.colors.whiteBlue};
	}
`;

export default function Chooser<T>({ options, onChange }: IProps<T>) {
	return (
		<Box flexDirection="row" justifyContent="space-between" flexWrap="wrap">
			{options.map((option, i) => (
				// This column has a minimum of 250px width to break on the flexWrap on mobile
				<Box key={i} mb={2}>
					<ChooserOption onClick={() => (typeof onChange === 'function' ? onChange(option) : null)}>
						<Flex justifyContent="space-between" flexGrow={1} alignItems="center">
							<Flex alignItems="center">
								<ChooserIconContainer>
									<Flex justifyContent="center" alignItems="center" style={{ height: '100%' }}>
										{option.icon}
									</Flex>
								</ChooserIconContainer>
								<Paragraph>{option.name}</Paragraph>
							</Flex>
							<Box size={24}>
								<ChevronRightIcon />
							</Box>
						</Flex>
					</ChooserOption>
				</Box>
			))}
		</Box>
	);
}
